/**
 * Por que a IA sugeriu a categoria que está no formulário (cronograma, tarefa 4). "IA: 4"
 * embaixo do campo não diz de onde veio o 4, e é isso que se vende: comercial pelo voto das
 * vistas, 3 eixos pelas marcas do equipamento, logo categoria 4.
 *
 * Eixo suspenso (0027): caminhão não paga por ele (Lei 13.103/2015), ônibus paga. A linha diz
 * qual dos dois aconteceu, lendo a categoria que o domínio sugeriu.
 *
 * Só **explica** a sugestão. Quem sugere é `categoria_sugerida`, no domínio; comercial sem
 * eixos contados continua sem sugestão, de propósito ("chute vira tarifa").
 */
import { grupoDaClasse } from "../leituras";

/** Quantos eixos cada categoria comercial cobra (tabela da ANTT; 7 é 5 ou mais). */
const EIXOS_DA_CATEGORIA: Record<number, number> = { 2: 2, 4: 3, 6: 4, 7: 5 };

export function origemDaSugestao({
  categoria,
  grupo,
  eixos,
  origemDosEixos,
  suspensos = 0,
}: {
  categoria: number | null;
  /** O grupo votado (`silhueta`): "Passeio", "Comercial" ou a classe como veio. */
  grupo: string | null;
  eixos: number | null;
  /** De onde vieram os eixos, como `motivoDosEixos` diz ("pelas marcas do equipamento"). */
  origemDosEixos: string | null;
  /** Quantos dos `eixos` estavam suspensos, na vista que contou. */
  suspensos?: number;
}): string | null {
  const g = grupoDaClasse(grupo);
  if (categoria == null) {
    if (g === "Comercial") {
      return "IA: comercial, mas não contou os eixos. Sem eixos não há categoria sugerida; escolha a categoria olhando a imagem.";
    }
    return null;
  }
  if (g === "Passeio") {
    return `IA sugere categoria ${categoria}: ${categoria === 8 ? "moto" : "passeio"}, pelo voto das vistas.`;
  }
  if (g === "Comercial" && eixos != null) {
    const origem = origemDosEixos ? ` (${origemDosEixos})` : "";
    const cobrados = EIXOS_DA_CATEGORIA[categoria];
    const suspenso =
      suspensos > 0
        ? cobrados != null && cobrados < eixos
          ? `, ${suspensos} suspenso${suspensos > 1 ? "s" : ""} não cobrado${suspensos > 1 ? "s" : ""} (veículo de carga)`
          : `, ${suspensos} suspenso${suspensos > 1 ? "s" : ""} cobrado${suspensos > 1 ? "s" : ""} (ônibus paga todos)`
        : "";
    return `IA sugere categoria ${categoria}: comercial com ${eixos} eixos${suspenso}${origem}.`;
  }
  return `IA sugere categoria ${categoria}.`;
}
